export default __webpack_public_path__ + "static/media/0x283366bb42ef49a994913baf22263c6562e588a4.17c75245.webp";